import { CitizenshipVM } from 'shell/view-models/citizenship';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<CitizenshipVM, keyof CitizenshipVM>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'citizenship',
    label: 'Cittadinanza',
  },
  {
    id: 'validityDate',
    label: 'Data validità',
  },
  {
    id: 'note',
    label: 'Note',
  },
];
